var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "20px",
    viewBox: "0 0 12 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Facebook") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BandSite",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Facebook",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99196483,2.86268774 L11.6001667,2.86268774 L11.6001667,0.00360752208 L8.31894343,0.00360752208 C8.31894343,0.00360752208 4.62941896,-0.243536863 3.68344495,3.35338292 C3.68344495,3.35338292 3.34080887,4.29669843 3.38786086,6.62101929 L1.97175609e-13,6.63107276 L1.97175609e-13,9.67167169 L3.38786086,9.66144709 L3.38786086,19.9390514 L7.70642202,19.9390514 L7.70642202,9.67167169 L11.1314985,9.67167169 L11.1314985,6.62101929 L7.70642202,6.62101929 L7.70642202,4.96412089 C7.70642202,3.88981073 8.2886315,2.86268774 9.99196483,2.86268774 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.e5321020a2f6011c3d6ecfa670bbe9bb.svg";
export { ForwardRef as ReactComponent };